// Curated Hugeicons (free) untuk kotak statistik JurusanStat.
// Disimpan sebagai key string di DB (stats[].icon), lalu dipetakan ke
// komponen ikon di sini. Dipakai bersama oleh ModalJurusanStats (picker)
// dan JurusanStats.vue (render).
import {
  UserMultipleIcon,
  UserGroupIcon,
  BookOpen01Icon,
  TeacherIcon,
  MortarboardIcon,
  Award01Icon,
  Certificate01Icon,
  Building06Icon,
  ChartUpIcon,
  ChartLineData01Icon,
  Briefcase01Icon,
  Calendar01Icon,
  StarIcon,
  GlobalIcon,
} from "@hugeicons/core-free-icons";

export const jurusanStatIcons = [
  { key: "students", label: "Mahasiswa", icon: UserMultipleIcon },
  { key: "group", label: "Grup / Komunitas", icon: UserGroupIcon },
  { key: "book", label: "Mata Kuliah", icon: BookOpen01Icon },
  { key: "teacher", label: "Dosen / Pengajar", icon: TeacherIcon },
  { key: "graduation", label: "Lulusan / Wisuda", icon: MortarboardIcon },
  { key: "award", label: "Penghargaan", icon: Award01Icon },
  { key: "certificate", label: "Sertifikat / Akreditasi", icon: Certificate01Icon },
  { key: "building", label: "Gedung / Fakultas", icon: Building06Icon },
  { key: "chart", label: "Statistik", icon: ChartUpIcon },
  { key: "chart-line", label: "Grafik", icon: ChartLineData01Icon },
  { key: "briefcase", label: "Karier", icon: Briefcase01Icon },
  { key: "calendar", label: "Agenda / Tahun", icon: Calendar01Icon },
  { key: "star", label: "Prestasi", icon: StarIcon },
  { key: "global", label: "Global / Internasional", icon: GlobalIcon },
];

export const jurusanStatIconMap = Object.fromEntries(
  jurusanStatIcons.map((i) => [i.key, i.icon])
);

export const getJurusanStatIcon = (key) => jurusanStatIconMap[key] || null;
